import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	ModalFooter,
	Flex,
} from "@chakra-ui/react";
import { Button } from "newui/components/Button";
import { useSafeFormikContext } from "hooks/useSafeFormikContext";
import { useState } from "react";
import { cn } from "utils/helpers";

type ModalNewProps = {
	maxWidth?: string;
	width?: string;
	bodyClassName?: string;
	cancelText?: string;
	children: React.ReactNode;
	contentClassName?: string;
	headerContent?: React.ReactNode | string;
	isOpen: boolean;
	padding?: boolean;
	submitText?: string;
	useDefaultFooter?: boolean;
	onClose: () => void;
	handleSubmit?: () => void;
	onCancel?: () => void;
};
export const ModalNew = ({
	children,
	isOpen,
	onClose,
	handleSubmit,
	onCancel,
	headerContent,
	contentClassName,
	bodyClassName,
	padding = true,
	width = "1130px",
	maxWidth = "90vw",
	cancelText = "Cancel",
	submitText = "Submit",
	useDefaultFooter = false,
}: ModalNewProps) => {
	const formik = useSafeFormikContext<any>();
	const submitForm = formik?.submitForm;
	const isFormikSubmitting = formik?.isSubmitting ?? false;
	const [isSubmitting, setIsSubmitting] = useState(isFormikSubmitting);

	const handleCancelClick = () => {
		onClose && onClose();
		onCancel && onCancel();
	};

	const handleSubmitClick = () => {
		!formik && setIsSubmitting(true);
		try {
			if (handleSubmit && submitForm) {
				throw Error(
					"only use handleSubmit if not using a FormikForm - set this handle method on your FormikForm"
				);
			}

			if (submitForm) {
				submitForm();
			}
		} finally {
			!formik && setIsSubmitting(false);
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size="xl"
			scrollBehavior="inside"
			isCentered
		>
			<ModalOverlay
				bg="blackAlpha.300"
				backdropFilter="blur(5px)"
			/>
			<ModalContent
				my="auto"
				borderRadius={padding ? "lg" : null}
				boxShadow="xl"
				display="flex"
				flexDirection="column"
				width={width}
				maxWidth={maxWidth}
				className={cn("w-[1130px] max-w-[90vw]", contentClassName)}
			>
				{headerContent ? (
					<ModalHeader
						tabIndex={-1}
						borderBottomWidth={headerContent ? "1px" : 0}
						py={headerContent ? "22px" : 0}
						className="border-quarternary"
					>
						{typeof headerContent === "string" ? (
							<div className="flex items-center justify-between pr-12">
								<h2 className="font-heading text-[36px] font-normal text-royal-blue">
									{headerContent}
								</h2>
							</div>
						) : (
							<>{headerContent}</>
						)}
						<ModalCloseButton size="lg" />
					</ModalHeader>
				) : null}

				<ModalBody
					py={padding ? 10 : 0}
					px={padding ? 6 : 0}
					className={cn("max-h-[90vh] px-10 py-6", bodyClassName)}
					onWheel={(e) => {
						// force scroll
						// const target = e.currentTarget;
						// target.scrollTop += e.deltaY;
					}}
				>
					{!headerContent ? (
						<ModalCloseButton
							size="lg"
							className="z-[999]"
						/>
					) : null}
					{children}
				</ModalBody>
				{useDefaultFooter && (
					<ModalFooter>
						<Flex
							gap={3}
							className="!w-full"
						>
							<Button
								style={{ width: "100%" }}
								onClick={handleSubmitClick}
								type="submit"
								data-testid="submit-button"
								disabled={isSubmitting}
							>
								{submitText}
							</Button>
							<Button
								btntype={"base"}
								style={{ width: "100%" }}
								onClick={handleCancelClick}
							>
								{cancelText}
							</Button>
						</Flex>
					</ModalFooter>
				)}
			</ModalContent>
		</Modal>
	);
};
